export default "__VITE_ASSET__CzQyR90A__"